const templatesPage = {
  folderMenu: {
    createNewFolderModalMessage: 'Create a new Folder to organize your Templates.',
    renameExistingFolderModalMessage: 'Your folders can be renamed anytime.'
  },
  templateList: {
    templateOptions: {
      duplicateTemplateModalMessage: 'Duplicate all of the Policies, Items, Documents and Language in your Template.',
      templateDetailsModalMessage: 'View or Edit your Template Details.'
    }
  },
  templateBuilder: {
    policiesPane: {
      addPolicyInstructions: 'Click on a policy from the list below to place it in your template.',
      createCustomPolicyModalInstructions: 'Creating a custom Policy Type is a flexible way to create your '
        + 'own policy requirements & coverage amounts.',
      editCustomPolicyModalInstructions: 'Modifications made to your custom policy will not affect any '
        + 'existing templates that this policy is already a part of.'
    },
    documentsPane: { addDocumentInstructions: 'Click on a document from the list below to place it in your template.' },
    languagePane: { addLanguageInstructions: 'Create custom Language that can be included in your Template.' },
    saveTemplateModal: {
      saveTemplateMessage: 'Name your template, enter a description for it, and select the folder it should '
        + 'be published into.'
    }
  }
};

const insuredsPage = {
  insuredOptions: {
    deleteInsuredMessage: 'Deleting this insured will permanently delete all of its records, and all information'
      + ' related to those records such as insurance policies, documents, etc. Are you sure want to delete this '
      + 'insured?',
    archiveInsuredMessage: 'Archiving this insured will archive all of its records, as well as any information'
      + ' tied to those records, such as insurance policies, documents, etc. Are you sure want to archive this '
      + 'insured? Insureds can be reactivated at any time.',
    reactivateInsuredMessage: 'Reactivating this insured will reactivate all of its records, as well as any'
      + ' information tied to those records, such as insurance policies, documents, etc. Are you sure'
      + ' want to reactivate this insured?'
  }
};

const insuredProfile = {
  policiesTable: {
    archivePolicy: 'Are you sure you want to archive this policy? Policies can be reactivated at any time.',
    reactivatePolicy: 'Are you sure you want to reactivate this policy?',
    deletePolicy: 'Are you sure you want to permanently delete this policy?',
    removeAgentModal: {
      title: 'Remove Agent?',
      acknowledgementLabel: 'I understand this action is irreversible.',
      confirmButtonLabel: 'Remove Agent',
      cancelButtonLabel: 'Cancel',
      getRemovalDescription: (agentName, agentEmail) => {
        const name = (agentName ?? '').trim();
        const email = (agentEmail ?? '').trim();
        let agentIdentity = 'This agent';

        if (name && email) agentIdentity = `${name} (${email})`;
        else if (name || email) agentIdentity = name || email;

        return `${agentIdentity} will be removed as the agent from this policy `
          + 'and every other policy on this record. They will no longer receive any future correspondence '
          + 'related to this record.';
      },
      getContactReplacementDescription: replacementContactName => 'This agent is currently the only contact email listed for '
        + `this insured. Removing them will replace it with ${replacementContactName || 'you'} as a placeholder so the insured is not `
        + 'left without a contact. You can edit this contact at any time.'
    }
  },
  documentsTable: {
    deleteDocument: 'Are you sure you want to permanently delete this document?',
    deleteExpiration: 'Are you sure you want to permanently delete this custom expiration?'
  },
  attachmentsTable: { deleteAttachment: 'Are you sure you want to permanently delete this attachment?' }
};

const projectDetailsPage = {
  recordOptions: {
    deleteRecordMessage: 'Deleting this record will permanently delete any information related to it, such '
      + 'as insurance policies & documents. Are you sure want to delete this record?',
    archiveRecordMessage: 'Archiving this record will archive any information related to it, such '
      + 'as insurance policies & documents. Records can be reactivated at any time.',
    reactivateRecordMessage: 'Reactivating this record will reactivate any information related to it, such '
      + 'as insurance policies & documents. Are you sure want to reactivate this record?'
  }
};

const adminPage = {
  users: {
    // TODO: add deactivation text if we decide to archive entities they own and/or remove them as watchers
    deactivateUser: 'Are you sure you want to deactivate this user? Users can be reactivated at any time.',
    activateUser: 'Are you sure you want to reactivate this user? '
  },
  departments: {
    archiveDepartment: 'Archiving this department will archive any projects and templates belonging to it. '
      + 'Departments can be reactivated at any time.',
    reactivateDepartment: 'Reactivating this department will reactivate any projects and templates that were auto-archived when the department was archived. '
      + 'Are you sure you want to reactivate this department?.'
  }
};

const tooltips = {
  comingSoon: 'Coming Soon!',
  projectDetails: {
    projectInformation: {
      projectOwner: 'The primary PINS User who is responsible for this project.  '
        + 'If a Project Owner exists, their contact information will be displayed for agents when submitting certificates into PINS',
      department: 'The department this project is listed under.',
      projectRequirements: 'The default requirement template assigned to this project.',
      activeInsureds: 'The number of active insureds that belong to this project.',
      approved: 'The percentage of approved insureds on this project.'
    },
    requirementInformation: {
      requirementContact: 'The record contact email(s) will override the Insured Contact Email. If you add email addresses in'
          + ' this field, those parties become the new recipients of outgoing PINS emails for this record.',
      requirementCc: 'Record CC contacts will be copied on record update emails instead of any insured CC contacts.'
    }
  },
  adminSettings: {
    users: {
      editUser: {
        emailAddress: 'To edit your own email address, use the User Settings menu. '
          + "To edit another user's email address, please contact support@pinsadvantage.com."
      }
    }
  },
  insureds: {
    newInsured: {
      primaryContactEmail: 'Email address for the primary insured contact.',
      secondaryContactEmails: "Email addresses for secondary contacts to be CC'd on emails.",
      defaultInsuranceRequirements: 'Select a default template for all projects this insured is assigned to.',
      insuredId: 'Any ID number associated to this insured.',
      businessType: 'The type of business the insured engages in.',
      insuredDescription: 'Any notes or description about the insured.',
      addToProject: {
        recordNumber: 'Any number associated to the instance of the insured on this project.',
        insuredRecordNotes: 'Any notes associated to the instance of the insured on this project.',
        recordWatcher: 'Any users who may want to keep track of the instance of the insured on this project.'
      }
    }
  },
  templates: {
    templateBuilder: {
      createCustomPolicy: {
        saveToListToggle: 'Save this custom policy if you wish to apply it to other templates'
          + ' in the future.',
        saveButtonDisabled: 'Add at least one Required Coverage field to save.',
        requiredCoverageHint: 'Add at least one coverage field using the Field Type dropdown below.'
      },
      createCustomDoc: {
        saveToListToggle: 'Save this custom document if you wish to apply it to other templates'
          + ' in the future.'
      },
      createCustomLang: {
        saveToListToggle: 'Save this custom language if you wish to apply it to other templates'
          + ' in the future.'
      },
      publishTemplate: {
        templateDescription: 'Any description for your template, to be displayed on main Templates page.',
        folder: 'The folder where your template should be published into. To place your template in '
          + "the Drafts folder, exit this modal and click 'Save As Draft'."

      },
      saveAsDraft: {
        templateDescription: 'Any description for your template, to be displayed on main Templates page.',
        folder: "All drafts saved into 'Drafts' folder."
      }
    },
    templateList: {
      templateOptions: {
        templateDetails: {
          templateDescription: "Edit this template's description.",
          folder: 'Change the folder this template currently belongs to.'
        }
      }
    },
    drafts: { draftOptions: { draftDetails: "Edit this draft's description." } }
  }
};

const cloningTray = {
  confirmModal: {
    title: 'Clone insurance? This action is irreversible.',
    confirmButtonLabel: 'Yes, Clone Insurance',
    cancelButtonLabel: 'Keep Editing',
    getDescription: ({ policyCount, documentCount, recordCount, copyRequirementStatuses }) => {
      const plural = (count, noun) => `${count} ${count === 1 ? noun : `${noun.replace(/y$/, 'ie') }s`}`;
      const statuses = copyRequirementStatuses
        ? ' Requirement statuses will also be copied onto requirements that are still Not Received.'
        : '';

      return `This will copy ${plural(policyCount, 'policy')} and ${plural(documentCount, 'document')} onto `
        + `${plural(recordCount, 'record')}.${statuses} The cloned policies and documents are created on each `
        + 'target record and cannot be automatically undone.';
    }
  }
};

export const inAppText = {
  templatesPage,
  insuredsPage,
  insuredProfile,
  projectDetailsPage,
  adminPage,
  tooltips,
  cloningTray
};
